<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="Название">
      <a-input v-model:value="filters.name" />
    </a-form-item>

    <a-row :gutter="10">
      <a-col>
        <a-form-item label="Активность">
          <a-input v-model:value="filters.job_title" placeholder="Название должности" />
        </a-form-item>
      </a-col>

      <a-col>
        <a-form-item label="Отдел">
          <a-input v-model:value="filters.department" placeholder="Название отдела" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="10">
      <a-col :span="12">
        <a-form-item label="Дата добавления" name="created_at">
          <a-date-picker
              v-model:value="filters.created_at"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>

      <a-col :span="12">
        <a-form-item label="Последнее изменение" name="updated_at">
          <a-date-picker
              v-model:value="filters.updated_at"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button class="secondary-button" @click="closeForm">
          Отменить
        </a-button>
      </a-col>

      <a-col>
        <a-button class="primary-button" @click="updateFilters">
          Применить
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { computed, reactive, ref, toRaw, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  emits: ['close'],

  setup(props, context) {
    const currentFiltersLine = ref('')
    const store = useStore()

    const storedFilters = computed(() => store.state.group.filters)

    const makeLocalFilters = (source = {}) => ({
      name: source.name ?? '',
      job_title: source.job_title ?? '',
      department: source.department ?? '',
      updated_at: source.updated_at ?? null,
      created_at: source.created_at ?? null,
    })

    const filters = reactive(makeLocalFilters(storedFilters.value))

    const formatFilterValue = (value) => {
      if (!value) {
        return ''
      }

      if (typeof value?.format === 'function') {
        return value.format('DD.MM.YYYY')
      }

      return value
    }

    const buildInputLineString = () => {
      const parts = []

      if (filters.name) {
        parts.push(`Название: ${filters.name}`)
      }

      if (filters.job_title) {
        parts.push(`Должность: ${filters.job_title}`)
      }

      if (filters.department) {
        parts.push(`Отдел: ${filters.department}`)
      }

      if (filters.created_at) {
        parts.push(`Дата создания: ${formatFilterValue(filters.created_at)}`)
      }

      if (filters.updated_at) {
        parts.push(`Последнее изменение: ${formatFilterValue(filters.updated_at)}`)
      }

      currentFiltersLine.value = parts.join(', ')
    }

    const updateFilters = () => {
      buildInputLineString()

      store.dispatch('group/setGroupFilters', {
        filters: {
          ...toRaw(filters),
        },
        filterString: currentFiltersLine.value,
      })

      closeForm()
    }

    const closeForm = () => {
      context.emit('close')
    }

    watch(storedFilters, () => {
      Object.assign(filters, makeLocalFilters(storedFilters.value))
    })

    return {
      filters,
      updateFilters,
      closeForm,
    }
  },
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>